import { LitElement, html } from 'lit';
import { TagKey } from '@cof/tag-catalog-fs-vehicle-and-loan-mfe';
import { DebugService } from '../../../shared/services/debug.service.js';
import { style } from './iconic-manual-loan.style.js';
import { globalStyle } from '../../../global-styles.style.js';
import './iconic-loan-inputs/iconic-loan-inputs.component.js';
import './iconic-loan-checks/iconic-loan-checks.component.js';
import { stratum } from '../../../../constants/stratum.js';
import { validateForm } from '../../../shared/decorators/validate-form.decorator.js';
import { preventEvDefault } from '../../../shared/decorators/prevent-ev-default.decorator.js';
import { vibrate } from '../../../shared/decorators/vibrate.decorator.js';
import { LoanService } from '../../../services/loan.service.js';
import { ApplicationService } from '../../../services/application.service.js';

class RefiIconicManualLoan extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiIconicManualLoan');

    this.showLoadingIcon = false;
    this.loansList = [];
    this.validity = {};

    this.loanObject = {};
  }

  connectedCallback() {
    super.connectedCallback();
    if (LoanService.isManualLoan && ApplicationService.selectedLoan) {
      this.loanObject = ApplicationService.selectedLoan;
      this.requestUpdate();
    }
    stratum.publishTag(
      ApplicationService.isInAppDeclineDelayOn
        ? TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOAN_MANUAL_2
        : TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOAN_MANUAL
    );
  }

  static properties = {
    loanObject: { type: Object, reflect: true },
  };

  static styles = [style, globalStyle];

  render() {
    return html`
      <form
        name="formManualLoan"
        id="manual-loan-form"
        @submit="${this.submitManualLoan}"
        autocomplete="off"
        novalidate
      >
        <refi-iconic-loan-inputs
          id="refiLoanInput"
          .loanObject="${this.loanObject}"
          @validity="${this.updateValidity}"
        ></refi-iconic-loan-inputs>

        <fs-button
          class="card-button"
          variant="primary"
          data-track="manual entry submit"
          >${LoanService.getSelectLoanButtonCTA(true)}</fs-button
        >
      </form>
    `;
  }

  updateValidity(ev) {
    this.debug.log('updated validity', ev.detail.name, ev.detail.isValid);
    this.validity[ev.detail.name] = ev.detail.isValid;
  }

  runBusinessChecks() {
    const loanInputComponent = this.shadowRoot.getElementById('refiLoanInput');
    loanInputComponent.runBusinessChecks();
  }

  updateLoanObject() {
    const loanInputComponent = this.shadowRoot.getElementById('refiLoanInput');
    loanInputComponent.updateLoanObject();
    this.loanObject = loanInputComponent.loanObject;
    this.dispatchEvent(
      new CustomEvent('update-manual-loan-object', { detail: this.loanObject })
    );
    this.requestUpdate();
  }

  @preventEvDefault()
  @vibrate(50)
  @validateForm()
  submitManualLoan() {
    let valid = true;
    for (const [key, value] of Object.entries(this.validity)) {
      const inputField = this.shadowRoot
        .getElementById('refiLoanInput')
        .shadowRoot.getElementById(key);
      if (inputField) {
        inputField.touched = true;
      }
      if (!value) {
        valid = false;
      }
    }
    this.runBusinessChecks();

    if (valid) {
      this.updateLoanObject();
      this.debug.log('emitting loanFormValidity');
      stratum.publishTag(
        ApplicationService.isInAppDeclineDelayOn
          ? TagKey.MANUAL_LOAN_ENTRY_MANUAL_ENTRY_SUBMIT_2
          : TagKey.MANUAL_LOAN_ENTRY_MANUAL_ENTRY_SUBMIT
      );
      this.dispatchEvent(
        new CustomEvent('loanFormValidity', {
          detail: {
            isManualLoan: true,
          },
        })
      );
    }
  }
}

customElements.define('refi-iconic-manual-loan', RefiIconicManualLoan);
